<template>
  <div class="more-photo">
    <div class="img-box" v-for="item in uploadArray" :key="item.storePhoto || item.uploadDtiCert || item.busiDocPhoto">
      <img class="upload-img" :src="item.storePhoto || item.uploadDtiCert || item.busiDocPhoto">
      <img class="close-icon" src="@/assets/html5/icon_close@2x.png"  @click="$emit('on-delete', item)">
    </div>

    <div class="empty-box" v-if="uploadArray.length < max">
      <el-upload
              class="uploader"
              action=""
              accept=".jpg,.jpeg,.png,.pdf"
              :show-file-list="false"
              :http-request="uploadImgSuccess"
              :before-upload="beforeImgUpload"

      >
        <img src="@/assets/img_id_empty.png">
      </el-upload>
    </div>


  </div>
</template>

<script>
  export default {
    name: "MorePhoto",
    props: {
      uploadArray:{
        type: Array,
        default() {
          return []
        }
      },

      max: {
        type: [String, Number],
        default: 5
      }
    }
  }
</script>

<style lang="scss" scoped>
  .more-photo {
    margin: 154px auto 126px;

    img {
      width: 100%;
      height: 100%;
    }

    .img-box {
      display: inline-block;
      position: relative;
      width: 256px;
      height: 156px;
      /*width: 48%;*/
      margin-bottom: 30px;
      margin-right: 50px;
      border: 1px solid #E5F5FE;
      border-radius: 8px;
      .close-icon {
        position: absolute;
        right: 5px;
        top: 5px;
        width: 20px;
        height: 20px;
        background: #fff;
        border-radius: 8px;
        cursor: pointer;
      }
      .upload-img {
        width: 100%;

      }
    }

    .empty-box {
      display: inline-block;
      width: 256px;
      height: 156px;
      cursor: pointer;
    }

  }
</style>